import { useReferralContext } from '../../context';

// No margin utility class on this <p> — see the base-layer note in
// ReferralForm/styles/index.scss if Magnolia margin ever leaks in here.
function ProAgreementText() {
  const { proInfo } = useReferralContext();

  return (
    <p
      className="text-gray-60 text-1 leading-lg text-left"
      data-testid="pro_agreement_text"
    >
      By providing your phone and email and selecting See My Pros, you agree to
      be contacted by {proInfo?.contact_name || 'your pro'} via email, phone,
      and/or texts, and to the use of an automatic telephone dialing system,
      artificial or prerecorded voice, and/or AI-generated messages to advertise
      and provide services to you. Messaging and data rates may apply. Frequency
      varies.
      <br></br>
      <br></br>
      You may opt out at any time, including by replying STOP to our texts.
      Consent isn’t required for products or services from the pro. However, if
      you opt out of receiving calls or text messages, you won't receive
      communications from the pro.
    </p>
  );
}

export { ProAgreementText };
